import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {DatePipe} from '@angular/common';

import {CookieService} from 'angular2-cookie/services/cookies.service';
import {
    AccountService,
    AuthorityService,
    AuthServerProvider,
    AuthService,
    CadensSharedCommonModule,
    CadensSharedLibsModule,
    CSRFService,
    HasAnyAuthorityDirective,
    Principal,
    StateStorageService,
    UserService
} from './';
import {InputRequiredDirective} from './input/input-required.directive';
import {ExportService} from './export/export.service';
import {SpinnerComponent} from './spinner/spinner.component';

@NgModule({
    imports: [
        CadensSharedLibsModule,
        CadensSharedCommonModule
    ],
    declarations: [
        HasAnyAuthorityDirective,
        InputRequiredDirective,
        SpinnerComponent
    ],
    providers: [
        CookieService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        AuthServerProvider,
        AuthService,
        UserService,
        AuthorityService,
        DatePipe,
        ExportService
    ],
    exports: [
        CadensSharedCommonModule,
        HasAnyAuthorityDirective,
        DatePipe,
        InputRequiredDirective,
        SpinnerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class CadensSharedModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts